module.exports = __webpack_public_path__ + "static/media/infographic-gamehive.4fa59280.png";